import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from '../domain/loginSlice';

export const sideMenuDefaultsMap = [
    {
        i18nKey: 'menu.logout',
        icon: LogoutIcon,
        route: '',
        action: logout
    }
]